import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/prana-club-new/prana-club-new/.build/app/src/app/(app)/[lng]/posts/[alias]/components/post/post.tsx");
